module.exports = {
  HiddenKpiUomValue: ["EA"],
  DefaultPageSize: 10,
  CountryCodeMapping: {
    "CN": "ml_143938",
    "TW": "ml_143939",
    "SEA": "ml_151371",
    "KR": "ml_143942"
  },
  KpiCategoryIdMapping: {
    "Safety": "S",
    "DrivingBehavior": "B",
    "EconomyKPI": "E",
    "ITToolUsage": "I",
    "Others": "T"
  },
  KpiPointPositiveValueIdList: [
    "T001"
  ],
  ITToolsUsageImportMapping: [
    {
      "storedKey": "rowNum",
      "csvKey": "Line No."
    },
    {
      "storedKey": "apexid",
      "csvKey": "Driver APEX ID"
    },
    {
      "storedKey": "kpidate",
      "csvKey": "Year"
    },
    {
      "storedKey": "kpiid",
      "csvKey": "KPI ID"
    },
    {
      "storedKey": "compliance",
      "csvKey": "Compliance"
    },
    {
      "storedKey": "compliance",
      "csvKey": "Compliance (Yes/No)"
    },
    {
      "storedKey": "kpidate",
      "csvKey": "Year and Month"
    },
    {
      "storedKey": "occurrence",
      "csvKey": "Occurance"
    },
    {
      "storedKey": "occurrence",
      "csvKey": "Count"
    },
    {
      "storedKey": "targetoccurrence",
      "csvKey": "Target"
    },
    {
      "storedKey": "sheetname",
      "csvKey": "sheetname"
    }
  ],
  DrivingBehaviorImportMapping: [
    {
      "storedKey": "rowNum",
      "csvKey": "Line No."
    },
    {
      "storedKey": "apexid",
      "csvKey": "Driver APEX ID"
    },
    {
      "storedKey": "kpitime",
      "csvKey": "Date"
    },
    {
      "storedKey": "kpiid",
      "csvKey": "KPI ID"
    },
    {
      "storedKey": "duration",
      "csvKey": "Duration"
    },
    {
      "storedKey": "speed",
      "csvKey": "Speed(KM)"
    },
    {
      "storedKey": "vehicle",
      "csvKey": "Vehicle"
    },
    {
      "storedKey": "classification",
      "csvKey": "Class"
    },
    {
      "storedKey": "kpilocation",
      "csvKey": "Location"
    },
    {
      "storedKey": "videourl",
      "csvKey": "Video URL"
    },
    {
      "storedKey": "description",
      "csvKey": "Description of Observation"
    },
    {
      "storedKey": "compliance",
      "csvKey": "Compliance"
    },
    {
      "storedKey": "gpsmonitor",
      "csvKey": "GPS Monitor"
    },
    {
      "storedKey": "sheetname",
      "csvKey": "sheetname"
    }
  ],
  EconomyImportMapping: [
    {
      "storedKey": "rowNum",
      "csvKey": "Line No."
    },
    {
      "storedKey": "apexid",
      "csvKey": "Driver APEX ID"
    },
    {
      "storedKey": "kpidate",
      "csvKey": "Year"
    },
    {
      "storedKey": "kpiid",
      "csvKey": "KPI ID"
    },
    {
      "storedKey": "kpiscore",
      "csvKey": "Score"
    },
    {
      "storedKey": "kpivalue",
      "csvKey": "Value"
    },
    {
      "storedKey": "reference",
      "csvKey": "Reference"
    },
    {
      "storedKey": "sheetname",
      "csvKey": "sheetname"
    }
  ],
  AchievementImportMapping: [
    {
      "storedKey": "rowNum",
      "csvKey": "Line No."
    },
    {
      "storedKey": "apexid",
      "csvKey": "Driver APEX ID"
    },
    {
      "storedKey": "mileage",
      "csvKey": "Monthly Mileage (KM)"
    },
    {
      "storedKey": "cylinder",
      "csvKey": "Monthly Cylinder Delivered (EA)"
    },
    {
      "storedKey": "cylinder",
      "csvKey": "Monthly Cylinder Delivered"
    },
    {
      "storedKey": "achieveDate",
      "csvKey": "Achievement Month"
    },
    {
      "storedKey": "sheetname",
      "csvKey": "sheetname"
    }
  ],
  AwardImportMapping: [
    {
      "storedKey": "rowNum",
      "csvKey": "Line No."
    },
    {
      "storedKey": "apexid",
      "csvKey": "Driver APEX ID"
    },
    {
      "storedKey": "awardname",
      "csvKey": "Award Name"
    },
    {
      "storedKey": "awarddate",
      "csvKey": "Award Date"
    },
    {
      "storedKey": "sheetname",
      "csvKey": "sheetname"
    }
  ],
  EDLJobs: [
    "All",
    "Terminal",
    "EM",
    "PGDriver",
    "LBDriver",
    "Score",
    "Achieve",
    "LearnEx"
  ],
  OccurrenceTargetEditableKPIs: [
    "I002",
    "I005"
  ]
}
